module.exports = __webpack_public_path__ + "img/sxt.235c5dc8.png";